<template>
    <div class="Speaker">
        <h2>主讲人介绍</h2>
        <p class="txt">{{Name}}</p>
        <div class="speakerCont">
            <p class="picBox" v-if='ThumPath != ""'><img :src="ThumPath"></p>
            <p v-if="company != ''">所属公司：{{company}}</p>
            <p v-if="Honor != ''">{{Honor}}</p>
            <p>{{Descript}}</p>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
        LectureID:0,  // 主讲人id
        ThumPath:'',  // 图片
        Name:'',  // 主讲人姓名
        Descript:'',  // 描述
        Honor:'',  // 荣誉
        company:'',  // 公司
    }
  },
  mounted(){
    // 获取unix时间戳到秒
    let timestamp = Date.parse(new Date())/1000;
    // 获取课程id
    this.LectureID = this.$route.params.id;
    let data = {
        "TimeStamp":timestamp,
        "ID":this.LectureID
    }
    this.$axios.post(Const_Api_Root+'api/Lecturer/Info',data,{
        contentType: 'application/json',
        dateType:'JSON',
        xHrFields: {withCredentials:true},
		beforeSend: function (XHR) {
			XHR.withCredentials = true;  // 跨域cookie支持代码
		}
    }).then((res)=>{
        // 错误提示
        if(res.data.Status == 0){
            this.Name = res.data.Data.Name;
            this.Descript = res.data.Data.Descript;
            this.Honor = res.data.Data.Honor;
            this.ThumPath = res.data.Data.ThumPath;
            this.company = res.data.Data.Company;
        }else if(res.data.Status != -2){
            this.$message({
                message: res.data.Data,
                type: 'error',
                duration: 3000
            });
        }
    }).catch((err)=>{
        throw err;
    });
  }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .Speaker{
        width: 100%;
        h2{
            font-size: 20px;
        }
        .txt{
            font-size: 12px;
            margin: 10px 0 32px;
        }
        .picBox{
            text-indent: 0;
        }
        img{
            width: 259px;
            height: auto;
        }
    }
}
@media screen and (min-width: 1029px) {
    .Speaker{
        width: 740px;
        margin: 0 auto 100px;
        h2{
            font-size: 30px;
        }
        .txt{
            font-size: 14px;
            margin: 20px 0 50px;
        }
        img{
            max-width: 400px;
            height: auto;
        }
    }
}
h2{
    color: #19191A;
    letter-spacing: 0;
    text-align: center;
}
.txt{
    color: rgba(25,25,26,0.80);
    letter-spacing: 0;
    text-align: center;
}
.speakerCont{
    margin-bottom: 50px;
    p{
        font-size: 14px;
        color: rgba(25,25,26,0.80);
        line-height: 28px;
        text-indent: 30px;
    }
    .picBox{
        text-align: center;
        text-indent: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/class/Speaker.vue